import { ReactNode } from 'react'
import { Grid, GridProps } from '@mui/material'

type GridContainerProps = {
  children: ReactNode
  marginInY?: string
  marginInX?: string
  justifyCenter?: boolean
  columnSpacing?: any
  rowSpacing?: any
}

export function GridContainer({
  children,
  marginInY,
  marginInX,
  spacing,
  justifyCenter,
  rowSpacing,
  columnSpacing,
  ...rest
}: GridContainerProps & GridProps) {
  return (
    <Grid
      container
      rowSpacing={rowSpacing || 2}
      columnSpacing={columnSpacing || { lg: 2, md: 2 }}
      direction="row"
      justifyContent={justifyCenter ? 'center' : 'flex-start'}
      marginY={marginInY || 'none'}
      marginX={marginInX || 'none'}
      {...rest}
    >
      {children}
    </Grid>
  )
}

type GridItemProps = {
  children?: ReactNode
  xs?: number
  sm?: number
  md?: number
  lg?: number
  xl?: number
}

export function GridItem({ children, xs, sm, md, lg, xl }: GridItemProps) {
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
      {children}
    </Grid>
  )
}
